import { ApiTriggerType } from "@superblocksteam/shared";
import { Flag } from "store/slices/featureFlags";
import { useListWorkflowsAndScheduledJobsQuery } from "store/slices/reduxApi/workflowsAndScheduledJobs";
import { useFeatureFlag } from "./useFeatureFlag";

/**
 * Hook to determine if scheduled jobs feature should be shown based on:
 * 1. Feature flag cloudprem.scheduled-jobs being enabled
 * 2. Organization having existing scheduled jobs (for conditional hiding)
 *
 * @returns {
 *   canCreateScheduledJobs: boolean - Can create new scheduled jobs (feature flag enabled)
 *   hasExistingScheduledJobs: boolean - Organization has existing scheduled jobs
 *   shouldShowScheduledJobs: boolean - Should show scheduled jobs in UI (flag enabled OR has existing scheduled jobs)
 * }
 */
export function useScheduledJobsEnabled() {
  const scheduledJobsFeatureFlagEnabled = useFeatureFlag(
    Flag.CLOUDPREM_SCHEDULED_JOBS,
  );

  const { data: workflowsAndScheduledJobs = [] } =
    useListWorkflowsAndScheduledJobsQuery(undefined, {
      refetchOnMountOrArgChange: false,
    });

  const hasExistingScheduledJobs = workflowsAndScheduledJobs.some(
    (api) =>
      api?.triggerType === ApiTriggerType.SCHEDULE ||
      api?.actions?.triggerType === ApiTriggerType.SCHEDULE,
  );

  return {
    canCreateScheduledJobs: scheduledJobsFeatureFlagEnabled,
    hasExistingScheduledJobs,
    shouldShowScheduledJobs:
      scheduledJobsFeatureFlagEnabled || hasExistingScheduledJobs,
  };
}
